'use client';
import React from 'react';

export default function AboutPlaceholderImage() {
  return (
    <section
      className="relative w-full overflow-hidden"
      style={{ minHeight: 'clamp(320px, 40vw, 560px)' }}>
      
      {/* Full-bleed background image */}
      <div style={{ position: 'absolute', inset: 0 }}>
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_1ddb5ca67-1772717106515.png"
          alt="Calm, warmly lit therapy room interior"
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: '50% 60%',
            display: 'block',
          }}
        />
      </div>
      
      <div
        className="absolute inset-0"
        style={{ background: 'linear-gradient(to right, rgba(26,35,50,0.85) 0%, rgba(26,35,50,0.4) 60%, rgba(26,35,50,0.1) 100%)' }} />
      
      <div
        className="relative z-10 flex flex-col justify-center"
        style={{
          minHeight: 'clamp(320px, 40vw, 560px)',
          padding: 'clamp(40px, 6vw, 80px) clamp(24px, 6vw, 96px)',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
        
        <blockquote style={{ maxWidth: '520px' }}>
          <p
            style={{
              fontFamily: 'orpheus-pro, Georgia, serif',
              fontSize: 'clamp(22px, 2.8vw, 40px)',
              fontWeight: '400',
              fontStyle: 'normal',
              color: '#E8D8D5',
              lineHeight: '1.4',
              marginBottom: '16px'
            }}>
            
            &ldquo;However long the night, the dawn will break.&rdquo;
          </p>
          <cite
            style={{
              fontFamily: 'adobe-garamond-pro, Georgia, serif',
              fontSize: '13px',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              color: 'rgba(239,227,225,0.5)',
              fontStyle: 'normal'
            }}>
            
            — African Proverb
          </cite>
        </blockquote>
      </div>
    </section>
  );
}
